import React from 'react'
import { Avatar, ToolTip } from "@driftt/tide-core-legacy"

const TooltipAvatar = ({ tooltipName, flow='up', type='user', team={}, user={}, company={} }) => (
  <ToolTip flow={flow} component={tooltipName}> 
    <Avatar type={type} team={team} user={user} company={company}/>
  </ToolTip>
)

export default TooltipAvatar



// WEBPACK FOOTER //
// ./src/scripts/components/TooltipAvatar/index.js